import { AttachmentWithOriginFileObj } from '@/types/order';

export const getFileSize = (file: File) => {
  return file.size;
};

export const getAttachmentsToUpload = (
  attachments: AttachmentWithOriginFileObj[]
): File[] => {
  return attachments
    .filter((f) => 'originFileObj' in f)
    .map((f) => f.originFileObj!);
};

export const prepareValueWithFiles = (
  value: Record<string, AttachmentWithOriginFileObj[]>,
  keys: string[]
): Record<string, unknown> => {
  const updatedValue: Record<string, unknown> = { ...value };
  for (const key of keys) {
    const attachments = value[key];
    if (attachments) {
      updatedValue[key] = getAttachmentsToUpload(attachments);
    }
  }
  return updatedValue;
};
